export type NavigationPreference = 'auto' | 'mouse' | 'trackpad';
export type NavigationMode = Exclude<NavigationPreference, 'auto'>;
export const NAVIGATION_KEY = 'aqueduct.navigationMode';

export function parseNavigation(value: unknown): NavigationPreference {
	return value === 'mouse' || value === 'trackpad' ? value : 'auto';
}

export function isDesktopMac(platform: string, maxTouchPoints: number, mobile = false): boolean {
	return !mobile && maxTouchPoints === 0 && /^(Mac|macOS)/.test(platform);
}

export function resolveNavigation(preference: NavigationPreference, mac: boolean): NavigationMode {
	return preference === 'auto' ? (mac ? 'trackpad' : 'mouse') : preference;
}

export type TrackpadMotion = { dx: number; dy: number; zoom: boolean; shift: boolean };
export function trackpadMotion(
	event: WheelEvent,
	mac: boolean,
	pageHeight: number
): TrackpadMotion {
	const mode: number = event.deltaMode;
	const units: number = mode === 1 ? 16 : mode === 2 ? Math.max(1, pageHeight) : 1;
	return {
		dx: event.deltaX * units,
		dy: event.deltaY * units,
		zoom: event.ctrlKey || (mac && event.metaKey),
		shift: event.shiftKey
	};
}

/** Positive scroll zooms out. Wheel pinch uses the logarithmic scale convention. */
export function trackpadZoomFactor(delta: number): number {
	return Math.exp(-delta * 0.01);
}
